import { moveTeamMembers } from './types';

export function requestMoveTeamMembers(sourceTeamId, targetTeamId, memberIds) {
  return {
    type: moveTeamMembers.request,
    memberIds,
    sourceTeamId,
    targetTeamId,
  };
}

export function requestMoveTeamMembersSuccess(members) {
  return {
    type: moveTeamMembers.success,
    members,
  };
}

export function requestMoveTeamMembersFailure(error) {
  return {
    type: moveTeamMembers.failure,
    error,
  };
}
